var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    transform: "translate(0 -0.164)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.164)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.843,19.9h-4.02a5.031,5.031,0,0,1-5.031-5.033V10.844A9.71,9.71,0,0,0,29.634,1,9.447,9.447,0,0,0,19.9,10.448v4.415A5.033,5.033,0,0,1,14.864,19.9h-4.02A9.712,9.712,0,0,0,1,29.052a9.449,9.449,0,0,0,9.445,9.739h4.415A5.033,5.033,0,0,1,19.9,43.824v4.018a9.708,9.708,0,0,0,9.156,9.84,9.448,9.448,0,0,0,9.739-9.443V43.824a5.031,5.031,0,0,1,5.031-5.033h4.417a9.448,9.448,0,0,0,9.443-9.739A9.712,9.712,0,0,0,47.843,19.9Z",
    transform: "translate(0.574 0.575)",
    fill: "#fff",
    stroke: "#d80063",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreReview);
export default __webpack_public_path__ + "static/media/moreReview.9e88d230e776de16b0adb6980f058e97.svg";
export { ForwardRef as ReactComponent };